<template>
    <div>
        <ul class="catalog-types">
            <li v-for="(filterType, index) in filterTypes" :class="{'active': getFilterSlug(filterType) === $route.params.catalog}">
                <router-link :to="urlPrefix + getFilterSlug(filterType)">
                    <span class="filter-icon" v-html="filterType.icon"></span>
                    <span>{{ getFilterTitle(filterType) }}</span>
                </router-link>
            </li>
        </ul>

    </div>

</template>
<script>
    import helpers from './../../helpers'
    export default {

        data: function() {
            return {
                helpers: helpers
            }
        },
        props: {
            filterTypes: {required: true},
        },
        mounted: function(){
        },
        computed: {
            urlPrefix: function() {
                return '/' + helpers.getLocale() + '/' ;
            },
        },
        methods: {
            getFilterTitle: function(filterType){
                if(helpers.getLocale() === 'nl'){
                    return filterType['title-nl']
                }

                return filterType['title-en']
            },
            getFilterSlug: function(filterType){
                if(helpers.getLocale() === 'nl'){
                    return filterType['slug-nl']
                }

                return filterType['slug-en']
            },
        }

    }
</script>
<style lang="scss" scoped>


    .filters ul li a{
        padding: 0 0;
    }

    li a {
        fill: #ADADAD;
        color: #ADADAD;
        border: 0;

        &:hover{
            fill: #1e1e1c;
        }
    }

    .active a {
        color: #1e1e1c;
        fill: #1e1e1c;
    }

    .catalog-types{
        margin-bottom: 50px;
    }

</style>



// WEBPACK FOOTER //
// resources/assets/js/site/components/catalog-filter/catalog-type-switcher.vue